import { InboxDTO, TaskDTO } from './../../api/plyca-dtos';
import { generateRandomIdentifier, UIService } from './../../ui.service';

import { Component, AfterContentInit, ElementRef, Optional, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';

import { ActivatedRoute } from '@angular/router';

import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../../ServiceLocator';
import { DatePipe } from '@angular/common';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'inboxusers',
  templateUrl: 'inboxusers.template.html',
  providers: [DialogService, UIService, DatePipe]
})
export class InboxUsersComponent extends BaseComponent implements AfterContentInit, OnDestroy {

  private loaded = false;
  elements = [];

  taskId: string;

  modalOpened: boolean;
  windowHash;

  inboxId: any;
  inboxDescription: any;
  private translationService: TranslateService;


  constructor(
    private header: HeaderActionsService, // Servicio para el componente sub-header título y botones
    private elem: ElementRef,                             // Referencia necesaria para el servicio anterior
    public plycaService: PlycaDataService,              // Servicio de accesoa REST de servidor
    public uiService: UIService,                       // Servicios de interfaz como: mostrar un mensaje, ...
    public waitService: WaitLoadingService,            // Servicio para mostrar la capa de espera mientras hay procesos que tarden
    // o haya que bloquear la pantalla
    // Al menos en todas las llamadas al servidor.
    // private translationService: TranslateService,        // Servicio para obtener los textos internacionalizados
    private configuration: Configuration,                  // Configuración de las urls de los REST de servidor
    //public router: Router,
    //public route: ActivatedRoute
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private datePipe: DatePipe,
    @Optional() protected activatedRoute: ActivatedRoute,
  ) {
    super();

    this.translationService = ServiceLocator.injector.get(TranslateService);

    this.taskId = dialogConfig['taskId'];
    this.inboxId = dialogConfig['inboxId'];
    this.inboxDescription = dialogConfig['inboxDescription'];
    this.windowHash = generateRandomIdentifier();
  }

  ngOnDestroy() {
    this.uiService = null;
    this.dialogConfig = null;
    this.dialogService = null;
    this.datePipe = null;
    this.header.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }



  // Método para inicializar el componente sub-header y habitualmente también el contexto de la ayuda.
  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.subscribe(this.header.addWindowAction(
      'General.close',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ),
      success => {
        this.ref.close();
      });

    if (this.taskId) {
      let observable = this.plycaService.get(this.configuration.TAKS_SERVICE_URL, this.taskId,
        {
          expand: 'expansionSet:WITH_USERS'
        }).pipe(finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        }
        ))
      this.subscribe(observable, (task: TaskDTO) => {
        if (task) {
          this.elements = task.inbox.usersWithAccess;
          this.calculateAccess();
        } else {
          this.elements = [];
        }
      });
    } else if (this.inboxId) {
      let observable = this.plycaService.get(this.configuration.INBOX_SERVICE_URL, this.inboxId,
        {
          expand: 'usersWithAccess'
        }).pipe(finalize(() => {
          this.loaded = true;
          this.waitService.cancelWaiting();
        }
        ));

      this.subscribe(observable, (inbox: InboxDTO) => {
        if (inbox) {
          this.inboxDescription = inbox['description'];
          this.elements = inbox['usersWithAccess'];
          this.calculateAccess();
        } else {
          this.elements = [];
        }
      });
    }
  }

  calculateAccess() {
    this.elements.forEach(element => {
      element.description = this.getDescription(element);
    });
  }

  isLoaded(): boolean {
    return this.loaded;
  }
  isLoadedResult() {
    return this.isLoaded() && (this.elements && this.elements.length > 0);
  }


  getDescription(element: any): string {

    let descripcionBuzon = "(" + this.inboxId + ") " + this.inboxDescription + ")";
    let description = "";
    if (element.inboxAccess) {


      description = description + this.translationService.instant('Audit.UsersTaskAccess.InboxAccess')
        .replace('#INBOX#)', descripcionBuzon);
      if (element.exclusiveAccess) {
        description = description + this.translationService.instant('Audit.UsersTaskAccess.RestrictedAccess');
      }
    } else if (element.substitutionAccess) {

      description = description + this.translationService.instant('Audit.UsersTaskAccess.SubstitutionAccess')
        .replace('#USER#', element.substitution.replacedUser.identifier) + '. ';



      description = description + this.translationService.instant('Audit.UsersTaskAccess.SubtitutionAccessDates')
        .replace('#DATE1#', this.datePipe.transform(element.substitution.initDate, 'dd/MM/yyyy HH:mm:ss'))
        .replace('#DATE2#', this.datePipe.transform(element.substitution.endDate, 'dd/MM/yyyy HH:mm:ss')) + '. ';

    }
    return description;
  }
}